// extracted by mini-css-extract-plugin
export var accordionButton = "landingAccordion-module--accordion-button--1a43a";
export var bodyContent = "landingAccordion-module--body-content--76972";